import {
  CLEAR_PROGRAM_MAP,
  FETCH_PROGRAM_MAP,
  FETCH_PROGRAM_MAP_ERROR,
  FETCH_PROGRAM_MAP_SUCCESS,
  FETCH_PROGRAM_MAPS,
  FETCH_PROGRAM_MAPS_ERROR,
  FETCH_PROGRAM_MAPS_SUCCESS,
  SAVE_PROGRAM_MAP,
  SAVE_PROGRAM_MAP_ERROR,
  SAVE_PROGRAM_MAP_SUCCESS,
} from './types';

const initialState = {
  maps: [],
  loading: false,
  error: false,
  selected: null,
  /** The map the editor has open (as a string; null for none or a new map); results for any other are dropped. */
  selectedMapId: null,
  /** The latest read of that map; an answer to an earlier one is stale. */
  selectedRequestId: null,
  selectedLoading: false,
  saving: false,
  visit: 0,
  writeRequestId: null,
};

const idOf = (programMapId) => (programMapId === null || programMapId === undefined ? null : String(programMapId));

const isLatestRead = (state, action) =>
  action.requestId === state.selectedRequestId && state.selectedRequestId !== null && idOf(action.programMapId) === state.selectedMapId;

const degreePlanningProgramMapsReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_PROGRAM_MAPS:
      return { ...state, loading: true, error: false };
    case FETCH_PROGRAM_MAPS_SUCCESS:
      return { ...state, loading: false, maps: action.payload };
    case FETCH_PROGRAM_MAPS_ERROR:
      return { ...state, loading: false, error: true };
    case FETCH_PROGRAM_MAP: {
      const selectedMapId = idOf(action.programMapId);
      // Opening another map takes the old one off at once, so nothing can show or save it under the new ID.
      const selected = state.selected && idOf(state.selected.programMapId) === selectedMapId ? state.selected : null;
      return { ...state, selected, selectedMapId, selectedRequestId: action.requestId, selectedLoading: true };
    }
    case FETCH_PROGRAM_MAP_SUCCESS:
      if (!isLatestRead(state, action)) return state;
      if (!action.payload || idOf(action.payload.programMapId) !== state.selectedMapId) return { ...state, selectedLoading: false, selectedRequestId: null };
      return { ...state, selectedLoading: false, selectedRequestId: null, selected: action.payload };
    case FETCH_PROGRAM_MAP_ERROR:
      if (!isLatestRead(state, action)) return state;
      return { ...state, selectedLoading: false, selectedRequestId: null, selected: null };
    case CLEAR_PROGRAM_MAP:
      return { ...state, selected: null, selectedMapId: null, selectedRequestId: null, selectedLoading: false, saving: false, writeRequestId: null, visit: state.visit + 1 };
    case SAVE_PROGRAM_MAP:
      return { ...state, saving: true, writeRequestId: action.requestId ?? null };
    case SAVE_PROGRAM_MAP_SUCCESS: {
      if (action.visit !== undefined && (action.visit !== state.visit || action.requestId !== state.writeRequestId)) return state;
      const map = action.payload;
      if (!map || state.selectedMapId === null || idOf(map.programMapId) !== state.selectedMapId) return { ...state, saving: false };
      // What a write returns is the map as Elements now holds it, newer than any read of it still on the way.
      return { ...state, saving: false, selected: map, selectedRequestId: null, selectedLoading: false };
    }
    case SAVE_PROGRAM_MAP_ERROR:
      if (action.visit !== undefined && (action.visit !== state.visit || action.requestId !== state.writeRequestId)) return state;
      return { ...state, saving: false };
    default:
      return state;
  }
};

export default degreePlanningProgramMapsReducer;
